import { isBefore, parseISO } from "date-fns"

import useWhatsNewQuery from "../../../api/staticSite/useWhatsNewQuery"
import useUserQuery from "../../../api/user/useUserQuery"

const useHasUnviewedWhatsNew = () => {
  const whatsNew = useWhatsNewQuery()
  const { lastViewedDateOfWhatsNew } = useUserQuery() ?? {}

  // どちらかがロード中の場合
  if (whatsNew === undefined || lastViewedDateOfWhatsNew === undefined) return false

  const lastViewed = lastViewedDateOfWhatsNew ? parseISO(lastViewedDateOfWhatsNew) : null

  // エラーなどでお知らせの取得が出来なかった場合
  if (!whatsNew.lastUpdated) return false

  // 一度もお知らせを閲覧したことがない場合
  if (!lastViewed) return true

  return isBefore(lastViewed, whatsNew.lastUpdated)
}

export default useHasUnviewedWhatsNew
